import { PageInfoService, UUIDService, WebToMobileService } from '@pulse/browser-shared';
import {
    EnrichmentPipe,
    PulseEvent,
    PulseEventMessage,
    TrackerConfigurations,
    isToggleOn,
} from '@pulse/common';
import { LocationHistoryTracker, TabManagerService, TabOpenerDetector } from '../services';

export class EventGlobalsPipe implements EnrichmentPipe<PulseEventMessage> {
    constructor(
        private historyTracker: LocationHistoryTracker,
        private tabManager: TabManagerService,
        private pageInfo: PageInfoService,
        private config: TrackerConfigurations,
        private openerDetector: TabOpenerDetector,
        private uuidService: UUIDService,
        private webToMobileService: WebToMobileService,
    ) {}

    enrich(message: PulseEventMessage): PulseEventMessage {
        const event: PulseEvent = { ...message.data };

        if (typeof event.data !== 'object' || event.data === null) {
            event.data = {};
        }

        (event as PulseEvent & { timestamp?: number }).timestamp = message.timestamp;

        event.event_id = this.uuidService.generate();
        event.data['metadata'] = {
            event_id_source: 'sdk',
        };

        if (this.config.customerID) {
            event.data['customer_id'] = this.config.customerID;
        }

        const webToMobileMetadataInfo = this.webToMobileService.getWebToMobileMetaInfo();

        if (webToMobileMetadataInfo?.['device_id']) {
            event.data['is_w2m'] = true;
            event.data['mobile_attributes'] = webToMobileMetadataInfo['mobile_attributes'];
        }

        if (isToggleOn(this.config.eventEnrichment, 'url')) {
            event.data['url'] = this.pageInfo.href();
        }

        if (isToggleOn(this.config.eventEnrichment, 'tab_id')) {
            event.data['tab_id'] = this.tabManager.getTabId();
            if (event.data['tab_id']) {
                const openerId = this.openerDetector.getOpener();

                if (openerId?.id) {
                    event.data['opener_tab_id'] = openerId.id;
                }
            }
        }

        if (
            this.historyTracker.previousUrl &&
            isToggleOn(this.config.eventEnrichment, 'previous_url')
        ) {
            event.data['previous_url'] = this.historyTracker.previousUrl;
        }

        if (this.pageInfo.referrer() && isToggleOn(this.config.eventEnrichment, 'referrer')) {
            event.data['referrer'] = this.pageInfo.referrer();
        }

        message.data = event;

        return message;
    }
}
